<template>
  <b-row class="bg-white border-4" no-gutters>
    <b-container
      tag="form"
      @submit.prevent="$emit('submit', data)"
      class="my-4"
    >
      <b-row class="d-flex justify-content-center">
        <slot name="top" />
        <b-col
          cols="12"
          md="9"
          v-for="(ct, index) in data.itens"
          :key="index"
          :class="{ 'my-2': ct.visible }"
        >
          <label for="" v-if="ct.visible && ct.component !== 'b-form-checkbox'"
            >{{ ct.label }} <small>{{ ct.small }}</small></label
          >
          <component
            :is="ct.component"
            :data="ct"
            :class="ct.class"
            v-model="ct.model"
            v-bind="ct.bind"
            v-if="ct.visible"
            :required="ct.required"
            @input="$emit('handleInput', ct)"
            no-resize
          >
          </component>
        </b-col>
        <slot name="bottom" />
        <slot />
      </b-row>
      <b-row class="mt-4 d-flex justify-content-center" no-gutters>
        <b-col cols="2">
          <b-button class="btn-transparent w-100" :to="data.routeBack"
            >Cancelar</b-button
          >
        </b-col>
        <b-col cols="2">
          <b-button class="btn-black ml-4 w-100" type="submit">Salvar</b-button>
        </b-col>
      </b-row>
    </b-container>
  </b-row>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
    },
  },
}
</script>
<style lang="scss">
label {
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  color: #6c757d;
  margin-bottom: 0;
}
</style>
